export default __webpack_public_path__ + "static/media/img_login@2x.38a24f64.png";